import { useEffect } from "react";

/**
 * ToolsBackdrop — Applique le motif "outils/maisons" en background du <body>
 * (via inline-style JS + classe .has-tools-pattern qui pilote un voile ::before
 * pour la lisibilité du contenu). Aucun élément dans l'arbre React → aucun
 * risque d'être peint AU-DESSUS du contenu applicatif via les règles de
 * stacking CSS (ce qui posait un bug d'affichage sur les pages avec beaucoup
 * de cartes / dialogs).
 */
export default function ToolsBackdrop() {
  useEffect(() => {
    const b = document.body;
    const prev = {
      backgroundImage: b.style.backgroundImage,
      backgroundRepeat: b.style.backgroundRepeat,
      backgroundSize: b.style.backgroundSize,
      backgroundAttachment: b.style.backgroundAttachment,
      backgroundColor: b.style.backgroundColor,
    };
    b.style.backgroundColor = "#F7F3EE";
    b.style.backgroundImage = `url(${process.env.PUBLIC_URL}/brand/pattern-color.jpg)`;
    b.style.backgroundRepeat = "repeat";
    b.style.backgroundSize = "520px auto";
    b.style.backgroundAttachment = "fixed";
    b.classList.add("has-tools-pattern");
    return () => {
      Object.assign(b.style, prev);
      b.classList.remove("has-tools-pattern");
    };
  }, []);
  return null;
}
